import React from "react";

const SpanForTooltip = React.forwardRef((props, ref) => (
  <span {...props} ref={ref} style={{ cursor: "default", ...props.style }}>
    {props.children}
  </span>
));

export default SpanForTooltip;
